import React from "react";
import { Outlet } from "react-router-dom";
import Link from "@/components/Link";

import './index.scss';

const Layout: React.FC = () => {
  return (
    <div className="app-container">
      
      <Outlet />
      <Link />
    </div>
  );
};

export default Layout;
